import React, { useContext, useEffect } from "react";
import {
    ButtonProps,
    ButtonRenderProps,
    ContentSection,
    createListTableColumns,
    ListTable,
    renderDateTime
} from "sprint-common-web";

import { getLanguageSpecificationDashboardHref } from "../../AdminRoutes";
import { CreateLanguageSpecificationButton } from "../create/buttons/CreateLanguageSpecificationButton";
import { LanguageSpecificationListingContext } from "./context/LanguageSpecificationListingContext";
import { LanguageSpecificationListingItem } from "./LanguageSpecificationListingItem";
import { useLanguageSpecificationListingFilters } from "./useLanguageSpecificationListingFilters";

export const LanguageSpecificationListing: React.VFC = () => {
    const { filters, setSort, setPage, setPageSize } = useLanguageSpecificationListingFilters();
    const { languageSpecificationItems: items, isLoading, totalItems, load } = useContext(
        LanguageSpecificationListingContext
    );

    useEffect(() => {
        load(filters);
    }, [filters.sortBy, filters.sortOrder, totalItems]);

    const columns = createListTableColumns<LanguageSpecificationListingItem>([
        {
            type: "link",
            key: "name",
            name: "Name",
            minWidth: 150,
            maxWidth: 200,
            isSortable: true,
            getHref: (item) => getLanguageSpecificationDashboardHref(item.id)
        },
        {
            type: "basic",
            key: "updatedDate",
            name: "Updated",
            minWidth: 50,
            maxWidth: 100,
            isSortable: true,
            onRender: renderDateTime
        }
    ]);

    const createLanguageSpecificationButtonProps: ButtonRenderProps<ButtonProps> = {
        render: CreateLanguageSpecificationButton
    };

    return (
        <ContentSection header="Language specifications" buttons={[createLanguageSpecificationButtonProps]}>
            <ListTable
                columns={columns}
                items={items}
                pagination={{
                    page: filters.page,
                    pageSize: filters.pageSize,
                    totalItems,
                    onPageChange: setPage,
                    onPageSizeChange: setPageSize
                }}
                sort={{ by: filters.sortBy, order: filters.sortOrder }}
                onSortChange={setSort}
                isLoading={isLoading}
            />
        </ContentSection>
    );
};
